import React from 'react';
import styled from 'styled-components';
import BannerCompanies from '../components/BannerCompanies ';
import SearchComponent from '../components/SearchComponent';

// Estilização da Tela
const Container = styled.div`
  width: 100%;
  background-color: #f4f6f9;
  min-height: 100vh;
  padding: 40px 20px;
`;



const BannerWrapper = styled.div`
  margin-bottom: 50px; /* Adiciona espaço abaixo do banner */
`;

const RelocationCompanies = () => {
  return (
    <Container>
      <BannerWrapper>
        <BannerCompanies />
          {/* Chamando o componente de busca */}
      <SearchComponent />
      </BannerWrapper>
    </Container>
  );
};

export default RelocationCompanies;
